import actionCreator from 'helpers/actionCreator'
import { UPDATE_CALCULATOR, BATCH_UPDATE_CALCULATOR, UPDATE_DISTANCE_ON_INTERVAL,
         CLEAR_UPDATE_DISTANCE_ON_INTERVAL } from 'actions/calculatorActionTypes'

/** Called as an action when a calculator value is changed */
export const updateCalculatorAction = actionCreator(UPDATE_CALCULATOR, 'value', 'key', 'id', 'fromMap')

/** Called as an action when calculator values change */
export const batchUpdateCalculatorAction = actionCreator(BATCH_UPDATE_CALCULATOR, 'values', 'keys', 'id', 'fromMap', 'skipRoundFocal')

/** Called when starting the update distance on interval saga */
export const updateDistanceOnIntervalAction = actionCreator(UPDATE_DISTANCE_ON_INTERVAL, 'increasing', 'id')

/** Called when stopping the update distance interval */
export const clearUpdateDistanceIntervalAction = actionCreator(CLEAR_UPDATE_DISTANCE_ON_INTERVAL)



// WEBPACK FOOTER //
// ./src/actions/calculatorActions.js